import React from 'react';
import { connect } from 'react-redux';
import { LoadingCard } from 'adc-ui-components';
import { getCwaRoot } from '../../helpers/eidServiceHero';

const getConnectedDeviceCount = (devices = []) => {
  if (!Array.isArray(devices)) return 0;
  return devices.filter(device => device.lob && device.lob !== 'phone').length;
};

const getDeviceCountMessage = count => (count
  ? `${count} Connected Device${count > 1 ? 's' : ''}`
  : '');

const DeviceCountHero = ({ loading, devices }) => {
  const count = getConnectedDeviceCount(devices);
  const message = getDeviceCountMessage(count);
  const headerImage = `${getCwaRoot()}svg/brand-updates/devices-header.svg`;

  return (
    <>
      <h2>Devices</h2>
      {loading ? (
        <LoadingCard />
      ) : (
        <div
          className="card card--hero-devices"
          data-tracking-module="section-devices"
        >
          <div className="card__content">
            <img className="mb24" width="516" src={headerImage} alt="" />
            {message && <h3 className="device-count-hero__message">{message}</h3>}
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ account }) => ({
  loading: account.loading,
  devices: account.devices ? account.devices.list : [],
});

export default connect(mapStateToProps)(DeviceCountHero);
